/**
 * 设计器全局配置：页面尺寸预设、字体选项、布局常量
 */

// ─── 布局 ─────────────────────────────────────────────────────────────────────

/** 左面板距上、左、下的边距；右面板距上、右、下的边距（影响面板坐标与高度） */
export const PANEL_MARGIN = 8;
/** 顶部元素 Toolbar 行高（与工作区 `top` 偏移对齐） */
export const ELEMENT_PANEL_TOOLBAR_HEIGHT = 60;
/** 元素 Popover 内容区宽度 */
export const ELEMENT_PANEL_WIDTH = 240;
/** 属性面板宽度（可与元素面板不一致） */
export const PROPERTY_PANEL_WIDTH = 220;
/** 底部画布控制工具条高度（px） */
export const TOOLBAR_HEIGHT = 60;

/** 工作区缩放倍率下限（20%） */
export const WORKSPACE_ZOOM_MIN = 0.2;
/** 工作区缩放倍率上限（200%） */
export const WORKSPACE_ZOOM_MAX = 2;

// ─── 表格默认 ─────────────────────────────────────────────────────────────────

/** 表格边线默认 */
export const TABLE_BORDER_COLOR = '#666666';
export const TABLE_BORDER_WIDTH = 1;
export const TABLE_BORDER_STYLE = 'solid' as const;

/** 拖拽调整行高/列宽时的最小行高、最小列宽（画布像素） */
export const TABLE_MIN_ROW_HEIGHT = 20;
export const TABLE_MIN_COL_WIDTH = 20;

/** 表格单元格默认内边距（px），作为单元格内边距的唯一来源 */
export const TABLE_CELL_PADDING_DEFAULT = 8;

/** 表格单元格默认文字大小（画布 px） */
export const TABLE_DEFAULT_FONT_SIZE = 32;
/** 表格单元格默认水平对齐 */
export const TABLE_DEFAULT_TEXT_ALIGN = 'center' as const;
/** 表格单元格默认垂直对齐 */
export const TABLE_DEFAULT_VERTICAL_ALIGN = 'middle' as const;
/** 表格单元格默认字重 */
export const TABLE_DEFAULT_FONT_WEIGHT = 400;
/** 表格单元格默认字色 */
export const TABLE_DEFAULT_TEXT_COLOR = '#000000';

// ─── 矢量图形内嵌文字默认 ──────────────────────────────────────────────────────

/** 矢量图形内嵌文字默认字号（画布 px） */
export const SHAPE_DEFAULT_FONT_SIZE = 32;
/** 矢量图形内嵌文字默认水平对齐 */
export const SHAPE_DEFAULT_TEXT_ALIGN = 'center' as const;
/** 矢量图形内嵌文字默认垂直对齐 */
export const SHAPE_DEFAULT_VERTICAL_ALIGN = 'middle' as const;
/** 矢量图形内嵌文字默认字重 */
export const SHAPE_DEFAULT_FONT_WEIGHT = 400;
/** 矢量图形内嵌文字默认字色 */
export const SHAPE_DEFAULT_TEXT_COLOR = '#000000';

// ─── 尺寸预设 ─────────────────────────────────────────────────────────────────

export interface PageSizePreset {
  id: string;
  name: string;
  width: number;
  height: number;
}

export const pageSizePresets: PageSizePreset[] = [
  { id: 'mobile-fullscreen', name: '手机全屏', width: 1290, height: 2796 },
  { id: 'square', name: '正方形', width: 1000, height: 1000 },
  { id: 'xiaohongshu', name: '小红书配图', width: 1242, height: 1660 },
  { id: 'wechat-header', name: '公众号首图', width: 900, height: 383 },
  { id: 'wechat-secondary', name: '公众号次图', width: 500, height: 500 },
  { id: 'vertical-video', name: '竖版视频封面', width: 1080, height: 1920 },
  { id: 'horizontal-video', name: '横版视频封面', width: 1920, height: 1080 },
  { id: 'product-main', name: '商品主图', width: 800, height: 800 },
  { id: 'ecommerce-detail', name: '电商详情页面', width: 750, height: 1000 },
  { id: 'a4', name: 'A4竖版', width: 794, height: 1123 },
  { id: 'a4-landscape', name: 'A4横版', width: 1123, height: 794 },
];
